"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            courses: null,
            programs: null,
            categories: []
        };
        this.fetchCourses();
        this.fetchPrograms();
    },
    onFilterByCategories: function (list) {
        this.state.categories = list;
        this.setStateDirty('categories');
    },
    fetchCourses: async function () {
        try {
            const {error, message, results} = await Request('/learner/course/explore/list');
            if (error)
                console.log('Error Fetching Courses: ', message);
            this.state.courses = results || [];
        } catch (error) {
            console.log('Error Fetching Courses');
            this.state.course = null;
        }
    },
    fetchPrograms: async function () {
        try {
            const {error, message, results} = await Request('/learner/program/explore/list');
            if (error)
                console.log('Error Fetching Programs: ', message);
            this.state.programs = results || [];
        } catch (error) {
            console.log('Error Fetching Programs');
            this.state.programs = null;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Explore/components/List.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    CategoryFilters_template = require("../../../components/CategoryFilters.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    CategoryFilters_tag = marko_loadTag(CategoryFilters_template),
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_Program_template = require("../../../components/Card-Program.marko"),
    Card_Program_tag = marko_loadTag(Card_Program_template),
    Card_Course_template = require("../../../components/Card-Course.marko"),
    Card_Course_tag = marko_loadTag(Card_Course_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("494f54"),
    marko_node0 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_node1 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node2 = marko_createElement("img", {
        src: "/images/illustration/introduction.png",
        "class": "img-fluid",
        alt: "illustration"
      }, "13", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", null, "0", component);

  CategoryFilters_tag({
      target: "explore"
    }, out, __component, "1", [
    [
      "init",
      "onFilterByCategories",
      false
    ],
    [
      "change",
      "onFilterByCategories",
      false
    ]
  ]);

  out.n(marko_node0, component);

  if ((state.courses == null) && (state.programs == null)) {
    LoadingPage_tag({}, out, __component, "3");
  } else if (((Array.isArray(state.courses) && Array.isArray(state.programs)) && (!state.courses.length)) && (!state.programs.length)) {
    out.be("div", marko_attrs0, "4", component);

    Row_tag({
        class: "m-0 w-100 d-flex align-items-center",
        renderBody: function(out) {
          WSAdapt_tag({
              class: "col",
              renderBody: function(out) {
                out.be("h5", null, "7", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Sorry, There is no course available");
                    }
                  }, out, __component, "8");

                out.ee();

                out.n(marko_node1, component);

                out.be("p", marko_attrs1, "10", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("In case you think this is an error, contact your administration.");
                    }
                  }, out, __component, "11");

                out.ee();
              }
            }, out, __component, "6");

          WSAdapt_tag({
              class: "col text-center",
              renderBody: function(out) {
                out.n(marko_node2, component);
              }
            }, out, __component, "12");
        }
      }, out, __component, "5");

    out.ee();
  } else {
    Row_tag({
        class: "m-0",
        renderBody: function(out) {
          if (Array.isArray(state.programs)) {
            marko_forOf(state.programs, function(program, index) {
              if ( !state.categories.length
              || !Array.isArray( program.categories )
              || !program.categories.length
              || program.categories.filter( ({ name }) => { return state.categories.includes( name ) } ).length ) {
                Card_Program_tag(program, out, __component, index);
              }
            });
          }

          if (Array.isArray(state.courses)) {
            marko_forOf(state.courses, function(course, index) {
              if ( !state.categories.length
              || !Array.isArray( course.categories )
              || !course.categories.length
              || course.categories.filter( ({ name }) => { return state.categories.includes( name ) } ).length ) {
                Card_Course_tag(course, out, __component, index);
              }
            });
          }
        }
      }, out, __component, "14");
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
